import {Col, Row} from "reactstrap";
import React, {useState, useEffect} from "react";
import {useTranslation} from "react-i18next";
import useApiCallService from "../../Common/Helpers/ApiCall";
import {ADMIN_PATHS} from "../../config";
import {useNavigate} from "react-router-dom";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import { SwedbankReportView } from "../Components/SwedbankReportView";
import ResponseSwedbankReport from "../Models/Response/ResponseSwedbankReport";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";
import { CheckMobile } from "../../AppSystem/Helpers/CheckMobile";

export function SwedBankPayReportInfo () {
    const { t } = useTranslation();
    const {ApiCall} = useApiCallService();
    const navigate = useNavigate();
    const isMobile = CheckMobile(998);
    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();

    const [responsePay, setResponsePay] = useState(new ResponseSwedbankReport());
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id') ?? "";

    useEffect(() => {
        setPageTitle(t('sidebar.swedbankReport'));
        setPageTitleKey('sidebar.swedbankReport');
        setOnBack(() => navigate(ADMIN_PATHS.ADMIN_SWEDBANK_REPORT));
        return () => { setPageTitle(''); setPageTitleKey(''); setOnBack(null); };
    }, [t]);

    useEffect(() => {
        const handlePayResponse  = (response) => {
            setResponsePay(response);
        };
        const PayApiCall = async () => {
            try {
                const apiCallOptions = {
                    method: "get",
                    url: `/swedbank/report?id=${id}`,
                };
                await ApiCall(apiCallOptions, handlePayResponse);
            } catch (error) {
                console.log('error', error);
            }
        };
        PayApiCall();
    }, []);

    return (
        <>
            {!isMobile && (
                <Row>
                    <Col lg={1} className="px-0">
                        <CustomButton
                            text={t('button.back')}
                            icon={'bx bx-chevron-left'}
                            buttonSize={'small'}
                            customClasses={'ms-3 mb-3'}
                            onClick={() => {
                                navigate(ADMIN_PATHS.ADMIN_SWEDBANK_REPORT)
                            }}
                        />
                    </Col>
                </Row>
            )}
            <Col lg={12} className="pb-5 px-0">
                <Row className="px-3">
                    <Col lg={12} className="py-4 card-backend px-0 px-lg-4">
                        {responsePay && responsePay.id !== "" ? (
                            <SwedbankReportView data={responsePay}/>
                        ) : ""}
                    </Col>
                </Row>
            </Col>
        </>
    );
}